import { pddFormTranslations } from '../../domain/forms/translations/pdd.form.translations';
export class FormTranslatorService {
    constructor(lang = 'en', formType = 'PDD') {
        this.lang = lang;
        this.formType = formType;
    }
    get translations() {
        switch (this.formType) {
            case 'PDD':
                return pddFormTranslations[this.lang];
            default:
                return {};
        }
    }
    getSectionTitle(sectionKey) {
        var _a, _b;
        return ((_b = (_a = this.translations.sections) === null || _a === void 0 ? void 0 : _a[sectionKey]) === null || _b === void 0 ? void 0 : _b.name) || sectionKey;
    }
    getSubSectionTitle(subSectionKey) {
        var _a, _b;
        return ((_b = (_a = this.translations.subSections) === null || _a === void 0 ? void 0 : _a[subSectionKey]) === null || _b === void 0 ? void 0 : _b.name) || subSectionKey;
    }
    getQuestionText(questionKey) {
        var _a, _b;
        return ((_b = (_a = this.translations.questions) === null || _a === void 0 ? void 0 : _a[questionKey]) === null || _b === void 0 ? void 0 : _b.question) || questionKey;
    }
    getQuestionContext(questionKey) {
        var _a, _b;
        return (_b = (_a = this.translations.questions) === null || _a === void 0 ? void 0 : _a[questionKey]) === null || _b === void 0 ? void 0 : _b.context;
    }
    getHelpText(questionKey) {
        var _a, _b;
        return ((_b = (_a = this.translations.questions) === null || _a === void 0 ? void 0 : _a[questionKey]) === null || _b === void 0 ? void 0 : _b.helpText) || '';
    }
    getAnswerLabel(answerKey) {
        var _a;
        return ((_a = this.translations.answers) === null || _a === void 0 ? void 0 : _a[answerKey]) || answerKey;
    }
    getValidationMessage(key, params) {
        var _a;
        const template = ((_a = this.translations.validationMessages) === null || _a === void 0 ? void 0 : _a[key]) || key;
        return params ? Object.entries(params).reduce((msg, [k, v]) => msg.replace(`{${k}}`, v), template) : template;
    }
    getActivityName(activityKey) {
        var _a;
        return ((_a = this.translations.activities) === null || _a === void 0 ? void 0 : _a[activityKey]) || activityKey;
    }
}
